import { render, staticRenderFns } from "./gameInfo.vue?vue&type=template&id=de07a7ae&scoped=true"
import script from "./gameInfo.vue?vue&type=script&lang=ts"
export * from "./gameInfo.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./gameInfo.vue?vue&type=style&index=0&id=de07a7ae&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "de07a7ae",
  "392ffce8"
  
)

export default component.exports